import { CheckboxFormField, FormSection, GridContainer, GridItem, SelectFormField } from "@duosoftbg/nacid-components";
import { useFormContext, useWatch } from "react-hook-form";
import React from "react";
import { useTranslation } from "react-i18next";
import RepresentativeKindFormFields from "./RepresentativeKindFormFields";
import { RepresentativeType } from "../../../../../../constants/representativeType";

const RepresentativeFormSection = () => {
  const { getValues } = useFormContext();
  const { t } = useTranslation();

  useWatch({ name: `isRepresentative` });
  useWatch({ name: `representativeType` });

  return (
    <FormSection label={"t.representative.details"}>
      <GridContainer spacing={4} mt={0}>
        <GridItem sm={12} md={12}>
          <CheckboxFormField fieldName={"isRepresentative"} labelCode={"l.person.isRepresentative"} />
        </GridItem>
      </GridContainer>
      {getValues().isRepresentative && (
        <>
          <GridContainer spacing={4} mt={0}>
            <GridItem>
              <SelectFormField
                required={true}
                fieldName={"representativeType"}
                labelCode={"l.person.representative.type"}
                selectOptions={[
                  {
                    text: t("l.person.representative.type.UNIVERSITY_REPRESENTATIVE"),
                    value: RepresentativeType.UNIVERSITY_REPRESENTATIVE,
                  },
                  {
                    text: t("l.person.representative.type.COMPANY_REPRESENTATIVE"),
                    value: RepresentativeType.COMPANY_REPRESENTATIVE,
                  },
                ]}
                addEmptyOption={false}
              />
            </GridItem>
          </GridContainer>
          <RepresentativeKindFormFields />
        </>
      )}
    </FormSection>
  );
};
export default RepresentativeFormSection;
